var React = require('react');

function ArrowRight2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 0V13.5H66.5M58 4.5L67 13.5L58.5 22","stroke":"#E1E1E1"}));
}

ArrowRight2.defaultProps = {"width":"68","height":"23","viewBox":"0 0 68 23","fill":"none"};

module.exports = ArrowRight2;

ArrowRight2.default = ArrowRight2;
